import React from "react";
import { Spin } from "antd";

export default () => <Spin />;
